/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from "axios";

export async function fetchUniversityGalleryByCollageName(
  country: string | undefined,
  setState: (images: string[]) => void,
  collageName: string | undefined
) {
  if (!country) return;
  try {
    const formattedCountry = country
      .replace("europe -", "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "_")
      .replace("united_states_of_america", "united_states");

    const response = await axios.get(
      `https://storage.googleapis.com/storage/v1/b/edvia_public_bucket/o?prefix=universities1/${formattedCountry}/${collageName}/gallery`
    );
    const images = response.data.items.map((item: any) => {
      const urlWithoutLastPart = item.id.substring(0, item.id.lastIndexOf("/"));
      return `https://storage.googleapis.com/${urlWithoutLastPart}`;
    });
    setState(images);
  } catch (error) {
    console.error("Error fetching university gallery:", error);
  }
}
